import { Component, OnInit } from '@angular/core';
import { DnbdashboardService } from './dnbdashboard.service'

@Component({
  selector: 'app-dnbdashboard',
  providers: [DnbdashboardService],
  templateUrl: './dnbdashboard.component.html',
  styleUrls: ['./dnbdashboard.component.css']
})
export class DnbdashboardComponent implements OnInit {
  myClients = [];

  // RS: current loading implementation can't handle empty results.
  // hence, we keep the flags that initiate them on false for now.
  loadingMyClients = false;

  constructor(
    private dashboardService: DnbdashboardService,
  ) { }

  ngOnInit() {
    this.getDnbClients();
  }

  getDnbClients() {
    this.dashboardService.fetchDnbClients()
      .subscribe(
      response => {
        this.loadingMyClients = true;
        if (response.arrResult.length == 0) {
            return;
          }
          this.myClients = this.myClients.concat(response.arrResult);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/dnbdashboard/dnbdashboard.component.ts